/* eslint-disable */
import * as util from "@/api/instagramAccount";

const state = {
    contactListArr: [],
    isShowForm: false,
    formParamSt: {
        copy: false,
        id: "",
        brand_id: [],
        brand_selected: [],
        ig: {
            id: "",
            username: "",
            password: ""
        }
    },
};

const mutations = {
    SET_contactListArr: (state, value) => {
        state.contactListArr = value
    },
    SET_formParamSt: (state, value) => {
        state.formParamSt = value
    },
    SET_isShowForm: (state, value) => {
        state.isShowForm = value
    },
};

const actions = {
    setContactListArr({ commit }, data) {
        commit("SET_contactListArr", data);
    },
    actionStored({ commit }, dataParam) {
        return new Promise((resolve, reject) => {
            util.actionStored(dataParam).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    detailEdit({ commit }, id) {
        return new Promise((resolve, reject) => {
            util.detailEdit(id).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    detail({ commit }, id) {
        return new Promise((resolve, reject) => {
            util.detail(id).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    create({ commit }, dataParam) {
        return new Promise((resolve, reject) => {
            util.create(dataParam).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    update({ commit }, dataParam) {
        return new Promise((resolve, reject) => {
            util.update(dataParam).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },

    setIsShowForm({ commit }, data) {
        commit("SET_isShowForm", data);
    },
    list({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.list(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listOfficial({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.list(params).then(response => {
                const { data } = response;
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listOfficialS({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listOfficial(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    actFormParamSt({ commit }, data) {
        commit("SET_formParamSt", data);
    },
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/instagramAccount.js